import { getStatusConfig } from 'enums/CertificationStatusEnum';

const toDate = value => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getQuarterEndDate = submission => {
  if (!submission?.quarter) {
    return null;
  }

  const { endDate, EndDate } = submission.quarter;
  return toDate(endDate || EndDate);
};

export const getDaysUntilQuarterEnd = (submission, referenceDate = new Date()) => {
  const quarterEndDate = getQuarterEndDate(submission);
  if (!quarterEndDate) {
    return null;
  }

  const startOfDay = new Date(referenceDate.getFullYear(), referenceDate.getMonth(), referenceDate.getDate());
  const endOfQuarterDay = new Date(quarterEndDate.getFullYear(), quarterEndDate.getMonth(), quarterEndDate.getDate());

  const differenceMs = endOfQuarterDay.getTime() - startOfDay.getTime();
  return Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
};

export const isSubmissionQuarterExpired = (submission, referenceDate = new Date()) => {
  const daysUntilEnd = getDaysUntilQuarterEnd(submission, referenceDate);
  if (daysUntilEnd === null) {
    return false;
  }

  return daysUntilEnd < 0;
};

export const isSubmissionFinalized = submission => {
  const statusConfig = getStatusConfig(submission?.status);
  return Boolean(statusConfig?.isFinal);
};

export const isSubmissionCompletedBucket = (submission, referenceDate = new Date()) => {
  return isSubmissionFinalized(submission) || isSubmissionQuarterExpired(submission, referenceDate);
};

export default {
  getQuarterEndDate,
  getDaysUntilQuarterEnd,
  isSubmissionQuarterExpired,
  isSubmissionFinalized,
  isSubmissionCompletedBucket,
};
